import 'css-chunksrc/client/common/resourceSelection/resources/resource/styles.scss';export default {
  "resource": "_resource_1sup7_1",
  "avatar": "_avatar_1sup7_15",
  "name": "_name_1sup7_22"
};